import { render, staticRenderFns } from "./ResultsMuseum.vue?vue&type=template&id=49d52c18&"
import script from "./ResultsMuseum.vue?vue&type=script&lang=js&"
export * from "./ResultsMuseum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports